import { render, staticRenderFns } from "./TmzReports.vue?vue&type=template&id=65f67ab6&scoped=true&"
import script from "./TmzReports.vue?vue&type=script&lang=js&"
export * from "./TmzReports.vue?vue&type=script&lang=js&"
import style0 from "./TmzReports.vue?vue&type=style&index=0&id=65f67ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f67ab6",
  null
  
)

export default component.exports